import { useEffect, useState } from 'react'
import { updateLoadingState } from '@sales-center/common'
import { getSalesTeam, getSalesTeamUsers } from '@user/store/salesTeam'
import { toast } from '@sales-center/components'
import { useAppDispatch } from '@user/store/hooks'
import { useBulkActionContext } from '@user/components/xGrid'
import { useSelector } from 'react-redux'
import { selectAllLeads } from '@user/store/lead'

export function useData() {
  const dispatch = useAppDispatch()
  const { selectedRows } = useBulkActionContext()
  const allLeads = useSelector(selectAllLeads)

  const [status, setStatus] = useState<'idle' | 'pending' | 'success' | 'fail'>(
    'idle',
  )

  useEffect(() => {
    if (selectedRows.length === 1) {
      const execute = async () => {
        try {
          setStatus('pending')
          const salesTeamId = allLeads.find(
            (lead) => lead.id === selectedRows[0],
          )?.salesTeamId
          dispatch(updateLoadingState('visible'))
          await dispatch(
            getSalesTeam({ id: salesTeamId || 0, includeUsers: true }),
          )

          const result = await dispatch(getSalesTeamUsers(salesTeamId || 0))
          if (getSalesTeamUsers.fulfilled.match(result)) {
            setStatus('success')
          } else {
            setStatus('fail')
            toast.error(`Error getting sales team users`)
          }
        } catch (error) {
          setStatus('fail')
          toast.error(`Error getting sales team users`)
        } finally {
          dispatch(updateLoadingState('hidden'))
        }
      }

      execute()
    } else {
      setStatus('success')
    }
  }, [allLeads, dispatch, selectedRows])

  return {
    status,
  }
}
